//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Object.js";
import "../no/Part.js";
let d=[[],[[[],"CreatePreferencesBuilder",{R_:{builder:"Annotations.PmiPreferencesBuilder"}},0,0],[["viewTag"],"CreatePmiEditSectionViewSettingsBuilder",{R_:{builder:"Annotations.PmiEditSectionViewSettingsBuilder"}},1,0],[["cpsTag"],"CreatePmiEditCuttingPlaneSymbolSettingsBuilder",{R_:{builder:"Annotations.PmiEditCuttingPlaneSymbolSettingsBuilder"}},1,0],[["regionTags"],"CreatePmiEditRegionSettingsBuilder",{R_:{builder:"Annotations.PmiEditRegionSettingsBuilder"}},1,0]],[]];
SPLM.Annotations.PmiSettingsManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Annotations.PmiSettingsManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;